var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSugar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.1 154.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Sgrcls-1 {\n        fill: #ffc2d9;\n      }\n\n      .Sgrcls-2 {\n        fill: none;\n      }\n\n      .Sgrcls-2, .Sgrcls-3 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .Sgrcls-3 {\n        fill: #468189;\n      }\n\n      .Sgrcls-4 {\n        fill: #ffebe7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_74",
    "data-name": "Layer 74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-4",
    x: 22.48,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 22.48,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_73",
    "data-name": "Layer 73"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 32.64,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 32.64,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_72",
    "data-name": "Layer 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 100.95,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 100.95,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_71",
    "data-name": "Layer 71"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 168.43,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 168.43,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_70",
    "data-name": "Layer 70"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 33.05,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 33.05,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_69",
    "data-name": "Layer 69"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 101.37,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 101.37,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_68",
    "data-name": "Layer 68"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 168.85,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 168.85,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_67",
    "data-name": "Layer 67"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 33.05,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 33.05,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_66",
    "data-name": "Layer 66"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 101.37,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 101.37,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_65",
    "data-name": "Layer 65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-1",
    x: 168.85,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Sgrcls-2",
    x: 168.85,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Sgrcls-3",
    cx: 20.63,
    cy: 20.63,
    r: 20.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugar);
export default __webpack_public_path__ + "static/media/Sugar.11f606b459947c85f7a0add2e3fac86a.svg";
export { ForwardRef as ReactComponent };